var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 21 21",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            { attrs: { transform: "translate(-207.000000, -398.000000)" } },
            [
              _c(
                "g",
                { attrs: { transform: "translate(0.000000, 341.000000)" } },
                [
                  _c("rect", {
                    attrs: {
                      fill: _vm.color,
                      x: "207",
                      y: "57",
                      width: "21",
                      height: "21",
                      rx: "10.5"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      fill: "currentColor",
                      transform:
                        "translate(217.500000, 67.772971) rotate(45.000000) translate(-217.500000, -67.772971) ",
                      x: "213",
                      y: "67.0229708",
                      width: "9",
                      height: "1.5"
                    }
                  }),
                  _vm._v(" "),
                  _c("polygon", {
                    attrs: {
                      fill: "currentColor",
                      transform:
                        "translate(217.500000, 67.772971) rotate(135.000000) translate(-217.500000, -67.772971) ",
                      points:
                        "213 67.0229708 222 67.0229708 222 68.5229708 217.610435 68.5229708 213 68.5229708"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }